'use client'

import { QuickSearchResponseRecord } from '@/search/types'
import { SearchResult } from '../SearchResult'
import { NoResults } from '../NoResults'
import { SearchWelcome } from '../SearchWelcome'
import { LoadingSpinner } from '@/General/LoadingSpinner'
import { resolveSearchDisplayPrice } from '@/lib/search/resolveSearchDisplayPrice'
import { useStorefrontMarket } from '@/useStorefrontMarket'
import { useCookieValue } from '@/Cookies/useCookies'
import {
  VAT_PREFERENCE_COOKIE,
  type VATPreference,
} from '@/vat/vatUtils'

export const SearchResultsList = ({
  results,
  isLoading,
  searchTerm,
}: SearchResultsListProps) => {
  const { currencyCode, currencySymbol, countryIsoCode } = useStorefrontMarket()
  const vatPreference = useCookieValue(VAT_PREFERENCE_COOKIE) as VATPreference

  return (
    <div>
      {isLoading ? (
        <LoadingSpinner />
      ) : !searchTerm ? (
        <SearchWelcome />
      ) : !results || results.length === 0 ? (
        <NoResults />
      ) : (
        results?.map(result => {
          const { price, salePrice } = resolveSearchDisplayPrice({
            result,
            currencyCode,
            countryIsoCode,
            vatPreference,
          })

          return (
            <SearchResult
              key={result.objectId}
              objectId={result.objectId}
              thumbnail={result.thumbnailUrl}
              title={result.title}
              productTypeDescription={result.productTypeDescription}
              creators={result.creators}
              salePrice={salePrice}
              price={price}
              currencySymbol={currencySymbol}
              inStock={result.inStock === 'true'}
              productUrl={result.productUrl}
            />
          )
        })
      )}
    </div>
  )
}

interface SearchResultsListProps {
  results: QuickSearchResponseRecord[]
  isLoading: boolean
  searchTerm: string
}
